import { combineReducers } from 'redux'
import {
  createRequestReducer,
  createReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeWorks = data => {
  const work = new schema.Entity('works')
  return normalize(data, [work])
}

const WorksReducer = combineReducers({
  fetchWorksRequest: createRequestReducer('WORKS_STORE:FETCH'),
  deletingWorkRequests: createMappedRequestReducer('WORKS_STORE:DELETE'),
  updatingWorkRequests: createMappedRequestReducer('WORKS_STORE:UPDATE'),
  pagination: createReducer(null, {
    'WORKS_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.account.student_type.works_pagination
  }),
  works: createReducer(null, {
    'WORKS_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeWorks(response.data.account.student_type.works),
    'WORKS_STORE:UPDATE_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      entities: {
        works: {
          ...state.entities.works,
          [params.id]: {
            ...state.entities.works[params.id],
            status:
              params.data.state === 'published' ? 'published' : 'unpublished'
          }
        }
      }
    })
  }),
  createAssessmentDialog: createReducer(
    { opened: false, selectedWorks: [] },
    {
      'WORKS_STORE:CREATE_ASSESSMENT_DIALOG:OPEN': (state, { params }) => ({
        ...state,
        opened: true,
        selectedWorks: params.selectedWorks
      }),
      'WORKS_STORE:CREATE_ASSESSMENT_DIALOG:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  )
})

export default WorksReducer
